export const isISODate = (isoDate: string) => {
  const isoDateRegex = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/
  return isoDateRegex.test(isoDate)
}
